<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .m-t-sm.pull-right(v-show="!onLoading('fetch-stock-return')")
            .dropdown.inline
                button.md-btn.md-raised.m-b-sm.white.m-r-sm.w-xs.dropdown-toggle(
                    data-toggle="dropdown",
                    :disabled="isLoading",
                    aria-expanded="false"
                ) Action
                .dropdown-menu
                    a.dropdown-item(:href="printUrl", target="_blank")
                        i.material-icons.m-r-sm print
                        | Print

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Stock Return
                li.breadcrumb-item.active {{ stockReturn.reference_id }}
    .padding(v-show="!onLoading('fetch-stock-return')")
        stock-return-info
        stock-return-stocks

        .box.dker(v-show="!onLoading('fetch-stock-return')", v-if="!hasFinalized")
            .box-body.text-right
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="isLoading",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green.m-r-sm(
                    :disabled="isLoading",
                    @click="saveChanges",
                    v-if="canEdit"
                )
                    v-loading(loader="save-stock-return") Save

                button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green(
                    :disabled="isLoading",
                    @click="markShipped",
                    v-if="canEdit"
                )
                    v-loading(loader="ship-stock-return") Mark as Shipped
</template>

<script>
import stockReturnMixin from './stock-return-mixin';
import stockReturnInfo from './stock-return-edit-info.vue';
import stockReturnStocks from './stock-return-edit-stocks.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stockReturnStocks, stockReturnInfo },

    mixins: [stockReturnMixin],

    computed: {
        isLoading() {
            return (
                this.onLoading('save-stock-return') ||
                this.onLoading('ship-stock-return') ||
                this.onLoading('fetch-stock-return')
            );
        },

        printUrl() {
            return Laroute.route('stock_returns.print', {
                id: this.stockReturn.id,
            });
        },
    },

    watch: {
        '$route.params.id': function(id) {
            if (!_.isNil(id)) {
                this.getStockReturn(id);
            }

            this.errors.clear();
        },
    },

    created() {
        this.getStockReturn(this.$route.params.id);
    },

    methods: {
        ...mapActions('stockReturn', ['getStockReturn', 'updateStockReturn']),

        cancel() {
            this.$router.push('/');
        },

        async saveChanges() {
            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updateStockReturn();
                this.swal({ text: 'Stock return has successfully saved' });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async markShipped() {
            if (!this.stockReturn.stocks.length) {
                this.swalWarning({
                    text: 'You must at least add a stock to proceed.',
                });

                return;
            }

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updateStockReturn(true);
                this.swal({
                    text: 'Stock return has successfully mark as shipped',
                });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async validateForm() {
            const validate = await this.$validator.validate();

            if (!validate) {
                // focus on error input
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }
            }

            return validate;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_return/stock-return-edit.vue